import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    Accept: 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('delivery_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // Clear auth state — no zustand persist to worry about since delivery uses React context
      localStorage.removeItem('delivery_token');
      localStorage.removeItem('delivery_token_created_at');
      localStorage.removeItem('delivery_user');
      // Use root path since app is at subdomain root, not /delivery/
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/?session_expired=1';
      }
    }
    return Promise.reject(error);
  },
);

export default api;
